import React from "react";

const VanRentalSubsections = ({ title, intro, subsections }) => {
  return (
    <section className="vr-subsections-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          {intro && <p>{intro}</p>}
        </div>

        <div className="row g-4">
          {subsections.map((sub, i) => (
            <div
              key={i}
              className="col-lg-6"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="vr-subsection-card">
                <h3>
                  {sub.icon && <i className={`bi ${sub.icon}`}></i>}
                  {sub.title}
                </h3>
                {sub.paragraphs.map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VanRentalSubsections;
